import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { CustomerProjectService } from 'pages/standard-setup/customer-projects/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(CustomerProjectService, DialogService, EventAggregator)
export class Statuses {
    constructor(customerProjectService, dialogService, ea) {
        this.ea = ea;
        this.customerProjectService = customerProjectService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'customerName', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'id' },
            { dataField: 'projectNumber' },
            { dataField: 'plantName' },
            { dataField: 'scrapAllowance' },
            { dataField: 'freightAllowance' },
            { dataField: 'packagingAllowance' },
            { dataField: 'otherAllowance' },
            { dataField: 'weldingStandardName', caption: 'Welding Standard' },
            { dataField: 'stampingStandardName', caption: 'Stamping Standard' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('customer-projects:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (customerProject) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.customerProjectService.delete(customerProject.id);
                this.grid.refresh();
                toastr.success('Customer project was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.customerProjectService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.customerProjectService.editor, model: { id: data.id } });
    };
}
